import React, { useReducer } from "react";
import FullScreenLoader from "../../components/fullScreenLoader/fullScreenLoader";
import TestQues from "../../components/testQues/testQues";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import TestFooterAudio from "../testFooterAudio/testFooterAudio";
import "./listenSpeak.scss";

const reducer = (state, action) => {
  switch (action.type) {
    case "":
      return;

    default:
      return;
  }
};
export default function ListenSpeak({ question, questions, index }) {
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC, dispatchHelper } = HelperContext();

  const { isLoading } = answerC;
  const [audioC, dispatchAudio] = useReducer(reducer);
  console.log("offSetHeight", helperC.offSetHeight);
  return (
    <>
      {/* this ternary condition is very important rather than and condition */}
      {isLoading ? (
        <FullScreenLoader msg="Please wait your audio is processing" />
      ) : (
        <>
          <div
            data-aos="zoom-in"
            className="test-body-content"
            style={{
              justifyContent: helperC.offSetHeight > 160 ? "initial" : "center",
            }}
          >
            <TestQues type="listenSpeak" question={question} />
          </div>

          <TestFooterAudio
            question={question}
            questions={questions}
            index={index}
          />
        </>
      )}
    </>
  );
}
